import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Bus } from './../../../models/bus';
import { BusAlertConf } from './../../../models/bus-alert-conf';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { Select2OptionData, Select2TemplateFunction } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
import * as moment from 'moment';
declare const google: any;
import { DrawingManager } from 'googlemaps';

@Component({
  selector: 'app-bus-add',
  templateUrl: './bus-add.component.html',
  styleUrls: ['./bus-add.component.css']
})
export class BusAddComponent implements OnInit {

  school: any;
  map: any;
  option: any;
  markers: any[];
  circles: any[];
  drawingManager: any;
  firstPolygon: any;
  slider: any;
  selectedAlerteIndex: any;
  markerBounds: any;
  directionsService: any;
  directionsRenderer: any;
  zones: any[];
  typeAlerteZone: Array<Select2OptionData>;
  iconeNameListe: Array<Select2OptionData>;
  bus: Bus;
  clients: any[];
  schools: any[];
  alerts: any[];
  assistants: any[];
  selectedAlerts: {};
  oldBusAlertConfs: any[];
  isAdmin: boolean;
  alertDesc: any[];
  phoneDriverInvalide: any = 0;
  simTrackerInvalide: any = 0;

  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public assistantsData: Array<Select2OptionData>;
  public sourceTypeTrakerData: Array<Select2OptionData>;
  public assistantOptions: Select2Options;
  public assistantCurrentValue: any;
  public assistantCurrentValueChanged: any;
  pnotify = undefined;

  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.bus = new Bus();
    this.clients = [];
    this.schools = [];
    this.alerts = [];
    this.zones = [];
    this.selectedAlerts = {};
    this.oldBusAlertConfs = [];
    this.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.sourceTypeTrakerData = [
      { id : 'SOURCEPOWEREXT', text: 'Externe' },
      { id : 'SOURCEPOWERINT', text: 'Interne' }
    ];
    this.typeAlerteZone = [
      { id: '1', text: 'Entrée' },
      { id: '2', text: 'Sortie' },
      { id: '3', text: 'Entrée/Sortie' }
    ];
    this.iconeNameListe = [
      { id: 'Ambulance', text: 'Ambulance' },
      { id: 'Bus', text: 'Bus scolaire' },
      { id: 'Camion', text: 'Camion' },
      { id: 'Colis', text: 'Colis' },
      { id: 'Fourgonnette', text: 'Fourgonnette' },
      { id: 'Moto', text: 'Moto' },
      { id: 'Ruche', text: 'Ruche' },
      { id: 'Taxi', text: 'Taxi' },
      { id: 'Voiture', text: 'Voiture' },
      { id: 'Velo-Taxi', text: 'Velo-Taxi' }
    ];
    this.initClientSelect();
    this.initSchoolSelect();
    this.initAlertSelect();
    this.bus.colorLineBus = "#0080FF"; // Init bus color
    this.alertDesc = [];
    this.pnotify = pnotifyService.getPNotify();

  }

  ngOnInit() {
    this.assistantOptions = {
      allowClear: true,
      placeholder: 'Choisir une assistante',
      templateResult: this.templateResult,
      templateSelection: this.templateSelection
    };
  }

  public templateResult: Select2TemplateFunction = (state: any): JQuery | string => {
    if (!state.id) {
      return state.text;
    }
    let content = '';
    if (state.assistant.Bus != null) {
      content = '<b style="color:red">' + state.text + '</b>';
    } else {
      content = '<span>' + state.text + '</span>';
    }
    return jQuery(content);
  }

  public templateSelection: Select2TemplateFunction = (state: any): JQuery | string => {
    if (!state.id) {
      return state.text;
    }
    let content = '';
    if (state.assistant.Bus != null) {
      content = '<b style="color:red">' + state.text + '</b>';
    } else {
      content = '<span>' + state.text + '</span>';
    }
    return jQuery(content);
  }

  iconeNameListeChanged(e){

  }

  sourceTypeChanged(e: any) {
    this.bus.sourceTypeTracker = e.value;
  }

  initMap(index) {
    let map;
    let center;

    center = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 0, lng: 0 };

    this.selectedAlerteIndex  = index;
    this.directionsService    = new google.maps.DirectionsService;
    this.directionsRenderer   = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    this.option = {
      center: center,
      zoom: 11,
      gestureHandling: 'cooperative'
    };
    
    map = new google.maps.Map(document.getElementById('zone-map'), this.option);
    this.map = map;
    this.directionsRenderer.setMap(map);

    // For Circle Zone
    /* if (this.bus.BusAlertConfs[index].zlat != 0 && this.bus.BusAlertConfs[index].zlng != 0 &&
      this.bus.BusAlertConfs[index].zlat != null && this.bus.BusAlertConfs[index].zlng != null){
      // init with existe param when it's a zone edit
      center = { lat: Number(this.bus.BusAlertConfs[index].zlat), lng: Number(this.bus.BusAlertConfs[index].zlng) };
      this.slider = this.bus.BusAlertConfs[index].zrayon;
    } else {
      // init with default param when it's new zone
      //center = { lat: Number(this.school.lat), lng: Number(this.school.lng) };
      center = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 0, lng: 0 };
      this.slider = '7000';
      this.bus.BusAlertConfs[index].zrayon = this.slider;
      this.bus.BusAlertConfs[index].zlat = center.lat;
      this.bus.BusAlertConfs[index].zlng = center.lng;
    } 

    this.markers = [];
    this.circles = [];
    const zoneCenterMarker = new google.maps.Marker({
      position: center,
      map: this.map,
      icon: 'assets/images/markers/zone-center.png',
      draggable: true,
      zIndex: 100,
    });
    this.markers.push(zoneCenterMarker);
    
    const zoneCircle = new google.maps.Circle({
      strokeColor: 'blue',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: 'blue',
      fillOpacity: 0.35,
      map: this.map, //pass the map object to show on the map.
      center: center, //or you can pass a google.maps.LatLng object
      radius:parseInt(this.slider) //radius of the circle in metres
    });
    this.circles.push(zoneCircle); 

    this.setMarker();*/
    
    // for Dynamic Zone
    if (this.bus.BusAlertConfs[index].zoneCoordinates != 0 && this.bus.BusAlertConfs[index].zoneCoordinates != null){
      // init with existe param when it's a zone edit
      
      //`coordinatesString` is the value retrieved from your database
      const storedCoordinatesString = this.bus.BusAlertConfs[index].zoneCoordinates;

      // Parse the JSON string into an array of coordinates
      const storedCoordinates = JSON.parse(storedCoordinatesString) as { lat: number, lng: number }[];

      // Draw the saved polygon on the map
      this.drawSavedPolygon(storedCoordinates);

    } else {

      // init with default param when it's new zone

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON],
        },
        polygonOptions: {
          strokeColor: 'blue',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: 'blue',
          fillOpacity: 0.35,
          editable: true,
        },
      });
  
      this.drawingManager.setMap(this.map);
  
      google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          this.handlePolygonComplete(event.overlay);
        }
      });
    }
  }

  // Function to draw a polygon on the map
  drawSavedPolygon(coordinates: { lat: number, lng: number }[]) {
    const polygon = new google.maps.Polygon({
      paths: coordinates,
      strokeColor: 'blue',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: 'blue',
      fillOpacity: 0.35,
      editable: true, // You can set this to false if you don't want the polygon to be editable
      map: this.map
    });

    // Add event listeners for polygon modification
    google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
      this.handlePolygonModification();
    });

    google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
      this.handlePolygonModification();
    });

    // Save the polygon reference if needed
    this.firstPolygon = polygon;
  }

  handlePolygonComplete(polygon) {

    // Store the polygon path in your data model
    const path = polygon.getPath();
    const coordinates = path.getArray().map(coord => ({ lat: coord.lat(), lng: coord.lng() }));
  
    
    // Convert the coordinates array to a JSON string
    const coordinatesString = JSON.stringify(coordinates);

    // Update your data model with the coordinates
    this.bus.BusAlertConfs[this.selectedAlerteIndex].zoneCoordinates = coordinatesString;
    
    console.log('coordinates',coordinatesString);

    // Disable drawing mode after the first polygon is drawn
    this.drawingManager.setOptions({
      drawingMode: null,
      drawingControl: false,
    });

    // Save reference to the first polygon
    this.firstPolygon = polygon;

    // Add event listeners for polygon modification
    google.maps.event.addListener(this.firstPolygon.getPath(), 'set_at', () => {
      this.handlePolygonModification();
    });

    google.maps.event.addListener(this.firstPolygon.getPath(), 'insert_at', () => {
      this.handlePolygonModification();
    });

  }

  handlePolygonModification() {
    // This function is called when the polygon is modified (vertex is moved or inserted)
    console.log('Polygon modification completed');
    // Add your logic here
    // Store the polygon path in your data model
    const path = this.firstPolygon.getPath();
    const coordinates = path.getArray().map(coord => ({ lat: coord.lat(), lng: coord.lng() }));
  
    // Convert the coordinates array to a JSON string
    const coordinatesString = JSON.stringify(coordinates);

    // Update your data model with the coordinates
    this.bus.BusAlertConfs[this.selectedAlerteIndex].zoneCoordinates = coordinatesString;
    console.log('coordinates',coordinatesString);
  }

 // *************** Function used for circle *****************
  setMarker() {
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.placeMarker(event);
    });

    // if we move the marker (glisser)
    google.maps.event.addListener(this.markers[0], 'dragend', (e) => {
      this.bus.BusAlertConfs[this.selectedAlerteIndex].zlat = e.latLng.lat();
      this.bus.BusAlertConfs[this.selectedAlerteIndex].zlng = e.latLng.lng();
      this.circles[0].setCenter(e.latLng);
    });
  }

  placeMarker(event) {
    if (this.markers[0]) {
      this.markers[0].setPosition(event.latLng);
      this.circles[0].setCenter(event.latLng);
    }
    this.bus.BusAlertConfs[this.selectedAlerteIndex].zlat = event.latLng.lat();
    this.bus.BusAlertConfs[this.selectedAlerteIndex].zlng = event.latLng.lng();
  }

  
  updateRadius(){
    this.circles[0].setRadius(this.slider);
    this.bus.BusAlertConfs[this.selectedAlerteIndex].zrayon = this.slider;
    // console.log(this.slider);
  }
// ***************************

  initClientSelect() {
    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      this.clientsData = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
    });
  }
  clientChanged(e: any) {
    this.bus.clientId = e.value;
    this.initSchoolSelect();
    this.initAssistantSelect();
  }

  initSchoolSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.bus.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map(function (school, index) {
        return { id: school.id, text: school.name };
      });
      this.schoolsData = array1.concat(array2);

    });
  }

  schoolChanged(e: any) {
    this.bus.schoolId = e.value;
  }

  colorChanged(e: any){
    this.bus.colorLineBus = e.target.value
  }

  initAssistantSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.bus.clientId + '',
        isAssistant: 'true'
      }
    });
    this.http.get(
      '/api/passenger/lookup',
      { params }
    ).subscribe((assistants: any) => {
      this.assistants = assistants.rows;
      const array1 = [{ id: '', text: 'Choisir une assistante' }];
      const array2 = this.assistants.map(function (assistant, index) {
        return { id: assistant.id, text: assistant.lastname, assistant: assistant };
      });
      this.assistantsData = array1.concat(array2);

    });
  }

  clearSelection() {
    this.assistantCurrentValue = '';
  }
  assistantChanged(e: any) {
    if (e.value !== '') {
      if (this.assistantCurrentValueChanged !== e.value) {
        this.assistantCurrentValue = e.value;
        this.http.get(
          '/api/passenger/' + e.value
        ).subscribe((data: any) => {
          const assistant = data.passenger;
          if (assistant != null) {
            if (assistant.Bus != null) {
              this.pnotify.notice({
                title: 'Confirmation',
                text: 'Cette assistante est liée au bus ' + assistant.Bus.name,
                stack: {
                  firstpos1: 70, firstpos2: 10,
                  modal: true,
                  overlay_close: true
                },
                hide: false,
                modules: {
                  Confirm: {
                    confirm: true,
                    buttons: [
                      {
                        text: 'Ok',
                        addClass: 'btn btn-chico',
                        click: notice => {
                          this.bus.assistantId = e.value;
                          notice.close();
                        }
                      },
                      {
                        text: 'Annuler',
                        addClass: 'btn btn-default',
                        click: (notice) => {
                          // this.assistantCurrentValue = undefined;
                          this.clearSelection();
                          notice.close();
                          notice.fire('pnotify.cancel', { notice });
                        }
                      }
                    ]
                  }
                }
              });
            } else {
              this.bus.assistantId = e.value;
            }
          }
        });
      }
    }
    this.assistantCurrentValueChanged = e.value;
    this.bus.assistantId = e.value;
  }

  initAlertSelect() {
    let params = new HttpParams({
      fromObject: {
        isAdmin: this.isAdmin + '',
      }
    });
    this.http.get(
      '/api/alert/lookup',
      { params }
    ).subscribe((alerts: any[]) => {
      this.alerts = alerts;
      this.updateSelectedAlerts();
    });
  }

  updateSelectedAlerts() {
    for (let i = 0; i < this.alerts.length; i++) {
      this.selectedAlerts[this.alerts[i].id] = {
        isAdmin: this.alerts[i].isAdmin,
        isDate: this.alerts[i].isDate,
        index: null
      };
    }
    for (let i = 0; i < this.bus.BusAlertConfs.length; i++) {
      if (this.bus.BusAlertConfs[i].alertId != null) {
        if (this.selectedAlerts.hasOwnProperty(this.bus.BusAlertConfs[i].alertId)) {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId].index = i;
        } else if (this.bus.BusAlertConfs[i].hasOwnProperty('Alert') &&
          this.bus.BusAlertConfs[i].Alert.id == this.bus.BusAlertConfs[i].alertId) {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId] = {
            isAdmin: this.bus.BusAlertConfs[i].Alert.isAdmin,
            isDate: this.bus.BusAlertConfs[i].Alert.isAdmin,
            index: i
          };
        } else {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId] = {
            isAdmin: true,
            isDate: false,
            index: i
          };
        }
      }
    }
  }

  changeAlert(event, index) {
    const isDate = this.selectedAlerts[this.bus.BusAlertConfs[index].alertId].isDate;
    // Show when it's Zone Alert
    if (this.bus.BusAlertConfs[index].alertId == 10){
      this.showZoneAlert(index);
    }
    Object.keys(this.selectedAlerts).forEach((alertId) => {
      if (this.selectedAlerts[alertId].index == index &&
        this.selectedAlerts[alertId].isDate != isDate) {
        this.bus.BusAlertConfs[index].value = '';
        return false;
      }
    });
    this.alertDesc[index] = this.alerts[event - 1].description;
    this.oldBusAlertConfs = this.bus.BusAlertConfs;
    this.updateSelectedAlerts();
  }


  addAlert() {
    this.bus.BusAlertConfs.push(new BusAlertConf());
    this.oldBusAlertConfs = this.bus.BusAlertConfs;
    this.updateSelectedAlerts();
  }

  showZoneAlert(index) {
    $('#ModalAlert').modal('show');
    setTimeout(() => {
      this.initMap(index);
    }, 500);
  }

  removeAlert(index) {
    this.alertDesc.splice(index, 1);

    let tmpBusAlertConfs = [];
    while (index < this.bus.BusAlertConfs.length - 1) {
      tmpBusAlertConfs.unshift(this.bus.BusAlertConfs.pop());
    }
    if (index == this.bus.BusAlertConfs.length - 1) {
      this.bus.BusAlertConfs.pop();
    }
    setTimeout(() => {
      while (tmpBusAlertConfs.length) {
        this.bus.BusAlertConfs.push(tmpBusAlertConfs.shift());
      }
      this.oldBusAlertConfs = this.bus.BusAlertConfs;
      this.updateSelectedAlerts();
    }, 10);
  }

  typeAlerteZoneChanged(e: any) {
    //this.journey.type = e.value;
    //this.refreshMap();
  }

  phoneNumberPatternValidator() {
    const phoneNumberPattern = /^0[6-7]{1}[0-9]{8}$/;
    
    // Phone Driver check
    if (phoneNumberPattern.test(this.bus.driverPhone)) {
      this.phoneDriverInvalide = 0; // Valid pattern
    } else {
      this.phoneDriverInvalide = 1; // Invalid pattern
    }

    // Phone SIM check
    if (phoneNumberPattern.test(this.bus.simTracker)) {
      this.simTrackerInvalide = 0; // Valid pattern
    } else {
      this.simTrackerInvalide = 1; // Invalid pattern
    }

  }


  checkFieldValidator () {
    this.phoneNumberPatternValidator(); // Check phone driver
  }

  onSubmit(): void {
    this.bus.simExpiration = moment(this.bus.simExpiration).format('YYYY-MM-DD HH:mm:ss');
    this.bus.BusAlertConfs.forEach((busAlert, index) => {
      //if (busAlert.alertId == 4 || busAlert.alertId == 5 || busAlert.alertId == 6) {
      if ([4, 5, 6, 13, 14, 15, 16, 17, 18, 19].includes(busAlert.alertId)) {
        this.bus.BusAlertConfs[index].value = moment(busAlert.value).format('YYYY-MM-DD HH:mm:ss');
      }
    });
    this.http.post(
      '/api/bus/0',
      { bus: this.bus }
    ).subscribe(
      (bus: Bus) => {
        this.bus = bus;
        this.router.navigate(['/bus/view', this.bus.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/bus/bus-add/bus-add.component.ts